module.exports = "/_next/static/images/sprite.external-6faaafe38d58610299e80c3c3aa7590c.svg";